/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = ko;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _jquery = __webpack_require__(2);

	var _jquery2 = _interopRequireDefault(_jquery);

	__webpack_require__(5);

	__webpack_require__(6);

	_jquery2['default'].ajaxSetup({
	  headers: {
	    'X-Requested-With': 'XMLHttpRequest'
	  }
	});

	var BaseApp = function BaseApp() {
	  _classCallCheck(this, BaseApp);
	};

	exports['default'] = BaseApp;
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var _knockout = __webpack_require__(3);

	var _knockout2 = _interopRequireDefault(_knockout);

	_knockout2['default'].bindingHandlers.init = {
	  init: function init(element, valueAccessor, allBindings, viewModel, bindingContext) {
	    var data = _knockout2['default'].unwrap(valueAccessor()),
	        $data = bindingContext.$data;
	    for (var key in data) {
	      if (_knockout2['default'].isObservable($data[key])) {
	        $data[key](data[key]);
	      }
	    }
	  }
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var _knockout = __webpack_require__(3);

	var _knockout2 = _interopRequireDefault(_knockout);

	_knockout2['default'].bindingHandlers.embed = {
	  init: function init() {
	    return {
	      controlsDescendantBindings: true
	    };
	  },
	  update: function update(element, valueAccessor) {
	    var value = _knockout2['default'].unwrap(valueAccessor());
	    if (!value) {
	      return;
	    }

	    var fireOnce = !!value.fireOnce;
	    var div = document.createElement('div');

	    value = value.value || value;
	    if (value instanceof HTMLElement) {
	      div.appendChild(value);
	    } else {
	      div.innerHTML = value;
	    }

	    _knockout2['default'].virtualElements.emptyNode(element);
	    if (fireOnce) {
	      _knockout2['default'].cleanNode(element);
	    }

	    var i = div.children.length;
	    while (i--) {
	      _knockout2['default'].virtualElements.prepend(element, div.children[i]);
	    }
	  }
	};

	_knockout2['default'].virtualElements.allowedBindings.embed = true;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _knockout = __webpack_require__(3);

	var _knockout2 = _interopRequireDefault(_knockout);

	var _modelsArticle = __webpack_require__(8);

	var _modelsArticle2 = _interopRequireDefault(_modelsArticle);

	var _viewmodelsPcBaseApp = __webpack_require__(4);

	var _viewmodelsPcBaseApp2 = _interopRequireDefault(_viewmodelsPcBaseApp);

	var App = (function (_BaseApp) {
	  _inherits(App, _BaseApp);

	  /**
	   * アプリケーションインスタンスを生成します。
	   *
	   * @constructor
	   * @throws {Error} 記事ページではない
	   */

	  function App() {
	    _classCallCheck(this, App);

	    _get(Object.getPrototypeOf(App.prototype), 'constructor', this).call(this);

	    var matches = location.pathname.match(/^\/(\d+)\/?$/);

	    if (!matches) {
	      throw new Error('');
	    }

	    this.favorited = _knockout2['default'].observable(false);
	    this.favorite = _knockout2['default'].observable(0);
	    this.article = new _modelsArticle2['default'](matches[1]);
	  }

	  _createClass(App, [{
	    key: 'onToggleFavorite',
	    value: function onToggleFavorite() {
	      if (this.favorited()) {
	        this.onRemoveFavorite();
	      } else {
	        this.onAddFavorite();
	      }
	    }

	    /** お気に入り追加時に実行するイベントハンドラ */
	  }, {
	    key: 'onAddFavorite',
	    value: function onAddFavorite() {
	      var _this = this;

	      this.article.addFavorite().done((function () {
	        _this.favorite(_this.favorite() + 1);
	        _this.favorited(true);
	      }).bind(this)).fail(function (jqXHR, textStatus, errorThrown) {
	        if ('Forbidden' === errorThrown) {
	          window.location.href = '/users/sign_in';
	          return;
	        }
	        alert('エラーが発生しました。');
	      });
	    }

	    /** お気に入り削除時に実行するイベントハンドラ */
	  }, {
	    key: 'onRemoveFavorite',
	    value: function onRemoveFavorite() {
	      var _this2 = this;

	      this.article.removeFavorite().done((function () {
	        _this2.favorite(_this2.favorite() - 1);
	        _this2.favorited(false);
	      }).bind(this)).fail(function () {
	        alert('エラーが発生しました。');
	      });
	    }
	  }]);

	  return App;
	})(_viewmodelsPcBaseApp2['default']);

	_knockout2['default'].applyBindings(new App());

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _jquery = __webpack_require__(2);

	var _jquery2 = _interopRequireDefault(_jquery);

	var Article = (function () {
	  /**
	   * Article インスタンスを生成します。
	   *
	   * @constructor
	   * @param {number} id 記事 ID
	   * @throws {TypeError} 変数 id が数値列ではない
	   */

	  function Article(id) {
	    _classCallCheck(this, Article);

	    if (!_jquery2['default'].isNumeric(id)) {
	      throw new TypeError();
	    }

	    id = +id;

	    /**
	     * 記事 ID を取得します。
	     *
	     * @return {number}
	     */
	    this.getId = function () {
	      return id;
	    };
	  }

	  /**
	   * 記事を削除します。
	   *
	   * ログインユーザで記事の削除を試みます。
	   *
	   * @return {jQuery.Promise}
	   */

	  _createClass(Article, [{
	    key: 'delete',
	    value: function _delete() {
	      return _jquery2['default'].ajax({
	        url: '/' + this.getId(),
	        type: 'DELETE'
	      });
	    }

	    /**
	     * 記事を複製します。
	     *
	     * @return {jQuery.Promise}
	     */
	  }, {
	    key: 'duplicate',
	    value: function duplicate() {
	      return _jquery2['default'].ajax({
	        url: '/duplicate/' + this.getId(),
	        type: 'POST'
	      });
	    }

	    /**
	     * お気に入りへ登録します。
	     *
	     * ログインユーザで記事のお気に入り登録を試みます。
	     *
	     * @return {jQuery.Promise}
	     */
	  }, {
	    key: 'addFavorite',
	    value: function addFavorite() {
	      return _jquery2['default'].ajax({
	        url: '/' + this.getId() + '/favorites',
	        type: 'POST'
	      });
	    }

	    /**
	     * お気に入りを解除します。
	     *
	     * ログインユーザで記事のお気に入り解除を試みます。
	     *
	     * @return {jQuery.Promise}
	     */
	  }, {
	    key: 'removeFavorite',
	    value: function removeFavorite() {
	      return _jquery2['default'].ajax({
	        url: '/' + this.getId() + '/favorites',
	        type: 'DELETE'
	      });
	    }
	  }]);

	  return Article;
	})();

	exports['default'] = Article;
	module.exports = exports['default'];

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** pc/article_view.js
 **/